module.exports = __webpack_public_path__ + "img/brand-logo2.7495914b.png";